import React, { Component } from 'react';
import { Formik, Field } from 'formik';
import { Link, Redirect } from 'react-router-dom';
import Button from '../utility/Button';
import CustomInput from '../utility/CustomInput';
import LoadingSpinner from '../utility/LoadingSpinner';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { validate6Digits } from '../../js/validators';
import { Helmet } from 'react-helmet';

import { getAuthErr } from '../../js/utility';

import { USER_NOT_CONFIRMED, SITE_TITLE } from '../../constants';

import { doSignIn, doResendCode, doConfirmSignUp } from '../../actions/auth';
import { toggleActiveAuthPopUp, setSignupFlow } from '../../actions/contest';

class Verify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      init: false
    };
  }

  componentDidMount() {
    this.init();
  }

  async init() {
    const { authError, doResendCode, email } = this.props;
    if (authError && authError.code === USER_NOT_CONFIRMED && email !== '') {
      await doResendCode(email);
    }
    this.setState({
      init: true
    });
  }

  render() {
    const {
      doConfirmSignUp,
      loading,
      authError,
      email,
      confirmed,
      t,
      contest,
      toggleActiveAuthPopUp,
      setSignupFlow
    } = this.props;
    const { init } = this.state;

    if (!init) {
      return <LoadingSpinner />;
    }

    if (confirmed) {
      return (
        <>
          <h1 className='fe-auth-heading'>{t('form:verifySuccess')}</h1>
          <div className='fe-auth-text'>{t('form:verifySuccessText')}</div>
          <div className='fe-auth-note'>
            {!contest ? (
              <Link to='/login'>{t('form:proceedToLogin')}</Link>
            ) : (
              <div
                onClick={() => {
                  toggleActiveAuthPopUp(false);
                  setSignupFlow('login');
                  toggleActiveAuthPopUp(true);
                }}
              >
                {t('form:proceedToLogin')}
              </div>
            )}
          </div>
        </>
      );
    }
    if (email === '') {
      return <Redirect to='/' />;
    }
    return (
      <>
        <Helmet>
          <title>
            {t('form:verifyAccount')} | {SITE_TITLE}
          </title>
        </Helmet>
        <h1 className='fe-auth-heading'>{t('form:verifyAccount')}</h1>
        <div className='fe-auth-text'>{t('form:verifyCodeText')}</div>
        <Formik
          validateOnChange={true}
          validateOnBlur={true}
          initialValues={{
            code: ''
          }}
          onSubmit={values => {
            doConfirmSignUp(email, values.code);
          }}
        >
          {({ handleSubmit }) => (
            <form noValidate onSubmit={handleSubmit} className='fe-form'>
              <div className='fe-form-content'>
                <div className='fe-form-field full'>
                  <label htmlFor='code'>{t('form:verificationCode')}</label>
                  <Field
                    type='text'
                    name='code'
                    numbersOnly
                    validate={validate6Digits}
                    component={CustomInput}
                  />
                </div>
                <Button className='btn-auth' type='submit' disabled={loading}>
                  {loading ? `${t('form:verifying')}...` : t('form:submit')}
                </Button>
              </div>
              <span className='fe-form-error'>
                {authError ? t(`error:${getAuthErr(authError.code)}`) : ''}
              </span>
            </form>
          )}
        </Formik>
      </>
    );
  }
}

Verify.propTypes = {
  authError: PropTypes.object,
  doResendCode: PropTypes.func.isRequired,
  email: PropTypes.string,
  doConfirmSignUp: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  confirmed: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ authState, contestState }) => ({
  user: authState.user,
  authError: authState.authError,
  loading: authState.loading,
  email: authState.email,
  confirmed: authState.confirmed,
  contest: contestState.contestMode
});

const mapDispatchToProps = {
  doSignIn,
  doResendCode,
  doConfirmSignUp,
  toggleActiveAuthPopUp,
  setSignupFlow
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Verify)
);
